import { pxToRem } from 'utils/convert';
import { BADGE_VARIANTS } from 'ui/badge';
import { EXPORT_DATA_TYPE, JOB_STATE, JOB_TYPE } from '../types';

const customSpacing = {
  p40: pxToRem(40),
};

export const TABLE_GRID = `
  minmax(${customSpacing.p40}, .5fr) // org id 
  minmax(${customSpacing.p40}, 2fr) // job name
  minmax(${customSpacing.p40}, .8fr) // job type
  minmax(${customSpacing.p40}, .8fr) // job status
  minmax(${customSpacing.p40}, .5fr) // org id
  minmax(${customSpacing.p40}, .8fr) // project id
  minmax(${customSpacing.p40}, .8fr) // recurring
  minmax(${customSpacing.p40}, 1fr) // start date
  minmax(${customSpacing.p40}, 1fr) // end date
  minmax(${customSpacing.p40}, 0.25fr) // Action menu
`;

export const DEFAULT_ROW_COUNT = 10;
export const SEARCH_TEXT_INPUT_DEBOUNCE_TIMEOUT_MS = 500;

export const jobNameMap: Record<JOB_TYPE, string> = {
  [JOB_TYPE.EXPORT_JOB]: 'Export job',
  [JOB_TYPE.TEST_JOB]: 'Test job',
  [JOB_TYPE.USER_RECORD_ANALYSIS_JOB]: 'User record analysis job',
};

export const jobTypeMap: Record<JOB_TYPE, string> = {
  [JOB_TYPE.EXPORT_JOB]: 'Export',
  [JOB_TYPE.TEST_JOB]: 'Test',
  [JOB_TYPE.USER_RECORD_ANALYSIS_JOB]: 'User record analysis',
};

export const jobStateToBadgeVariant: Record<JOB_STATE, string> = {
  [JOB_STATE.CANCELLING]: BADGE_VARIANTS.ABORTED,
  [JOB_STATE.COMPLETED]: BADGE_VARIANTS.FINISHED,
  [JOB_STATE.ENQUEUED]: BADGE_VARIANTS.READY,
  [JOB_STATE.FAILED]: BADGE_VARIANTS.ABORTED,
  [JOB_STATE.RUNNING]: BADGE_VARIANTS.RUNNING,
};

export const mapDataTypeToLabel: Record<EXPORT_DATA_TYPE, string> = {
  [EXPORT_DATA_TYPE.EMAIL_SEND]: 'Email Send',
  [EXPORT_DATA_TYPE.EMAIL_OPEN]: 'Email Open',
  [EXPORT_DATA_TYPE.EMAIL_CLICK]: 'Email Click',
  [EXPORT_DATA_TYPE.HOSTED_UNSUBSCRIBE_CLICK]: 'Hosted Unsubscribe Click',
  [EXPORT_DATA_TYPE.EMAIL_COMPLAINT]: 'Email Complaint',
  [EXPORT_DATA_TYPE.EMAIL_BOUNCE]: 'Email Bounce',
  [EXPORT_DATA_TYPE.EMAIL_SEND_SKIP]: 'Email Send Skip',
  [EXPORT_DATA_TYPE.PUSH_SEND]: 'Push Send',
  [EXPORT_DATA_TYPE.PUSH_OPEN]: 'Push Open',
  [EXPORT_DATA_TYPE.PUSH_UNINSTALL]: 'Push Uninstall',
  [EXPORT_DATA_TYPE.PUSH_BOUNCE]: 'Push Bounce',
  [EXPORT_DATA_TYPE.PUSH_SEND_SKIP]: 'Push Send Skip',
  [EXPORT_DATA_TYPE.IN_APP_SEND]: 'In-App Send',
  [EXPORT_DATA_TYPE.IN_APP_OPEN]: 'In-App Open',
  [EXPORT_DATA_TYPE.IN_APP_CLICK]: 'In-App Click',
  [EXPORT_DATA_TYPE.IN_APP_CLOSE]: 'In-App Close',
  [EXPORT_DATA_TYPE.IN_APP_DELETE]: 'In-App Delete',
  [EXPORT_DATA_TYPE.IN_APP_DELIVERY]: 'In-App Delivery',
  [EXPORT_DATA_TYPE.IN_APP_SEND_SKIP]: 'In-App Send Skip',
  [EXPORT_DATA_TYPE.IN_APP_RECALL]: 'In-App Recall',
  [EXPORT_DATA_TYPE.INBOX_SESSION]: 'Inbox Session',
  [EXPORT_DATA_TYPE.INBOX_MESSAGE_IMPRESSION]: 'Inbox Message Impression',
  [EXPORT_DATA_TYPE.SMS_SEND]: 'SMS Send',
  [EXPORT_DATA_TYPE.SMS_BOUNCE]: 'SMS Bounce',
  [EXPORT_DATA_TYPE.SMS_CLICK]: 'SMS Click',
  [EXPORT_DATA_TYPE.SMS_RECEIVED]: 'SMS Received',
  [EXPORT_DATA_TYPE.SMS_SEND_SKIP]: 'SMS Send Skip',
  [EXPORT_DATA_TYPE.WEB_PUSH_SEND]: 'Web Push Send',
  [EXPORT_DATA_TYPE.WEB_PUSH_CLICK]: 'Web Push Click',
  [EXPORT_DATA_TYPE.WEB_PUSH_SEND_SKIP]: 'Web Push Send Skip',
  [EXPORT_DATA_TYPE.EMAIL_SUBSCRIBE]: 'Subscribe',
  [EXPORT_DATA_TYPE.EMAIL_UNSUBSCRIBE]: 'Unsubscribe',
  [EXPORT_DATA_TYPE.PURCHASE]: 'Purchase',
  [EXPORT_DATA_TYPE.CUSTOM_EVENT]: 'Custom Event',
  [EXPORT_DATA_TYPE.USER]: 'User',
  [EXPORT_DATA_TYPE.SMS_USAGE_INFO]: 'SMS Usage Info',
  [EXPORT_DATA_TYPE.EMBEDDED_SEND]: 'Embedded Send',
  [EXPORT_DATA_TYPE.EMBEDDED_SEND_SKIP]: 'Embedded Send Skip',
  [EXPORT_DATA_TYPE.EMBEDDED_CLICK]: 'Embedded Click',
  [EXPORT_DATA_TYPE.EMBEDDED_DISMISS]: 'Embedded Dismiss',
  [EXPORT_DATA_TYPE.EMBEDDED_RECEIVED]: 'Embedded Received',
  [EXPORT_DATA_TYPE.EMBEDDED_IMPRESSION]: 'Embedded Impression',
  [EXPORT_DATA_TYPE.EMBEDDED_SESSION]: 'Embedded Session',
};
